module.exports = __webpack_public_path__ + "img/inc.650247c.png";